<template>
  <Modal :title="$t('global.add-mailbox')" @close="close">
    <template #body>
      <span>{{ $t("global.email-box-creation-disabled") }}</span>
    </template>
    <template #footer>
      <Btn variant="primary" @click="close">
        {{ $t("global.close") }}
      </Btn>
    </template>
  </Modal>
</template>

<script>
import Btn from "@/components/display/Btn";
import Modal from "@/components/display/Modal";

export default {
  name: "EmailBoxAddDisabledModal",
  components: {
    Btn,
    Modal,
  },
  props: {},
  setup(props, { emit }) {
    const close = () => emit("close");

    return {
      close,
    };
  },
};
</script>
